import React from 'react';

const LoanProtectionToggle = ({ isProtected, onChange }) => {
  return (
    <div className="flex items-center space-x-2">
      <button
        type="button"
        onClick={() => onChange(!isProtected)}
        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${
          isProtected ? 'bg-green-500' : 'bg-gray-600'
        }`}
        data-testid="loan-protection-toggle"
      >
        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${
            isProtected ? 'translate-x-6' : 'translate-x-1'
          }`}
        />
      </button>
      <span className={`text-sm font-medium ${isProtected ? 'text-green-400' : 'text-gray-400'}`}>
        {isProtected ? 'Protected' : 'Unprotected'}
      </span>
    </div>
  );
};

export default LoanProtectionToggle;
